export enum StorageState {
    Normal = "normal",
    Nearing = "nearing",
    Critical = "critical",
    Exceeded = "exceeded"
}
